<template>
    <div class="details">
        <div @click="close" class="overlay"></div>
        <main>
            <header>
                <Icon @click.native="close" class="close-icon" name="close"/>
                <h4>File uploader</h4>
            </header>
            <section class="profile-layout">
                <LazyImage :file="user.photoURL || ''"
                           class="image"
                           size="40px"/>
                <p class="name">{{user.displayName}}</p>
                <p class="email">{{user.email}}</p>
            </section>
            <section class="stats">
                <UserSectionStat :value="statsFilesCount" title="Files"/>
                <UserSectionStat :value="statsFilesSize" title="Total size"/>
                <UserSectionStat :value="statsShortedLinks" title="Shorted links"/>
            </section>
            <section class="buttons">
                <NiceButton @click="deleteAccountClicked" icon="delete" title="Delete my account"/>
                <NiceButton @click="signOutClicked" icon="login" title="Sign out"/>
            </section>
            <section>
                <LazyImage file="/assets/built-with-firebase.svg" size="300px" size2="150px"/>
            </section>
        </main>
    </div>
</template>

<script>
    import * as firebase from 'firebase/app';
    import 'firebase/firestore';
    import 'firebase/auth';
    import UserSectionStat from '../components/UserSectionStat';
    import LazyImage from '../components/LazyImage';
    import Icon from '../components/Icon';
    import {formatSize, listenForUser} from '../other/page-global';
    import NiceButton from '../components/NiceButton';

    export default {
        name: 'AccountDetailsDialog',
        components: {NiceButton, Icon, LazyImage, UserSectionStat},
        data() {
            return {
                user: null,
                statsFilesCount: '0',
                statsFilesSize: '0',
                statsShortedLinks: '0'
            };
        },
        methods: {
            async signOutClicked() {
                try {
                    await firebase.auth().signOut();
                    location.reload();
                } catch (e) {
                    alert(e.message);
                }
            },
            async deleteAccountClicked() {
                if (!confirm('Are you sure about this?\nThis will delete all your uploaded files!'))
                    return;
                try {
                    await this.user.delete();
                    location.reload();
                } catch (e) {
                    if (e.code !== 'auth/requires-recent-login') {
                        alert(e.message);
                        return;
                    }

                    if (!confirm(e.message)) return;
                    await this.signOutClicked();
                }
            },
            close() {
                this.$emit('blur');
            },
            onStatsSnapshot(snapshot) {
                const data = snapshot.data();
                if (data) {
                    this.statsFilesSize = formatSize(data.size);
                    this.statsFilesCount = `${data.files}`;
                    this.statsShortedLinks = `${data.links}`;
                }
            },
            userLoaded(user) {
                this.user = user;
                if (this.watchStatsUnsub) {
                    this.watchStatsUnsub();
                    this.watchStatsUnsub = null;
                }
                if (user) {
                    this.watchStatsUnsub = firebase
                        .firestore()
                        .collection('user-stats')
                        .doc(user.uid)
                        .onSnapshot(this.onStatsSnapshot);
                }
            }
        },
        created() {
            this.listenerUnsub = listenForUser(this.userLoaded);
        },

        destroyed() {
            this.listenerUnsub();
            if (this.watchStatsUnsub) {
                this.watchStatsUnsub();
                this.watchStatsUnsub = null;
            }
        }
    };
</script>

<style scoped>

    .details {
        animation: FadeIn .3s;
        cursor: default;
        font-size: initial;
        position: fixed;
        display: grid;
        place-items: center;
        z-index: 30;
        right: 0;
        left: 0;
        top: 0;
        bottom: 0;
    }

    .overlay {
        background-color: #00000099;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        position: absolute;
    }

    main {
        animation: DialogOpenAnimation .3s;
        background-color: #051e34;
        min-width: 40vw;
        max-width: 400px;
        margin: 16px;
        position: absolute;
        border-radius: 12px;
        box-shadow: 2px 1px 6px black;
    }

    header {
        font-size: 1.1em;
        display: flex;
        /*grid-template-columns: 32px auto 32px;*/
        align-items: center;
        padding: 4px;
    }

    header h4 {
        letter-spacing: 0.1em;
        font-weight: bold;
        margin: 8px;
    }

    .close-icon {
        cursor: pointer;
    }

    main > * {
        padding: 4px;
        border-bottom: 1px solid #555;
    }

    main > :last-child, main > :first-child {
        border-bottom: none;
    }

    .profile-layout {
        text-align: left;
        display: grid;
        padding: 8px 16px;
        grid-template-areas: 'image name' 'image email';
        grid-template-columns: 48px auto;
        grid-gap: 4px;
    }

    .image {
        grid-area: image;
        border-radius: 50%;
    }

    .name {
        grid-area: name;
        font-weight: bold;
        margin: 0;
    }

    .email {
        margin: 0;
        font-size: .9em;
        font-weight: normal;
        opacity: .83;
        grid-area: email;
    }


    .stats {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-evenly;
    }

    .buttons {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
</style>
